import React, {useState} from "react";
import {Grid, Typography, Button,     Dialog,
    DialogActions,
    DialogContent,} from "@mui/material";
import EmailReportModal from "../email-report-modal";
import SuccessDialog from "../success-dialog";
import { sendUsageReport } from "../../shared/api";
import {useSelector} from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";

const CustomerReporting = () => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() - 1);

    const [reportRange, updateReportRange] = useState({
        from: maxDate,
        to: maxDate
    });

    const [showEmailReportModal, setShowEmailReportModal] = useState(false);

    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const [showReportGenerationInProgress, setShowReportGenerationInProgress] = useState(false);

    const token = useSelector((state) => state.dataStore.getIn(["loginInfo", "authorizationToken"]));

    const onChange = (field) => (event) => {
        updateReportRange({
            ...reportRange,
            [field]: event.value
        })
    };

    const validateReportRange = () => {
        if (reportRange.from === null || reportRange.to === null) return false;
        return reportRange.from <= reportRange.to;
    };

    function formatDate(date) {
        const yyyy = date.getFullYear().toString();
        const mm = (date.getMonth() + 1).toString(); // getMonth() is zero-based
        const dd  = date.getDate().toString();
        return yyyy + '-' + (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]); // padding
    }

    const handleEmailReport = () => {
        if(!validateReportRange()) return;
        setShowEmailReportModal(true);
    };

    const handleCancelEmailReport = () => {
        setShowEmailReportModal(false);
    };

    const handleSendEmailReport = async (emailList) => {
        setShowReportGenerationInProgress(true);
        setShowEmailReportModal(false);
        await sendUsageReport(emailList, formatDate(reportRange.from), formatDate(reportRange.to), token);
        setShowReportGenerationInProgress(false);
        setShowSuccessDialog(true);
    };

    return <Grid container spacing={3} className={"usage-report"}>
        <Grid item xs={12}>
            <Typography component={"h1"} variant={"h1"}>
                Run Custom Reporting
            </Typography>
        </Grid>
        <Grid item xs={6}>
            <Typography className={"report-range-label"} component={"span"} variant={"span"}>
                From:
            </Typography>
            <DatePicker value={reportRange.from} onChange={onChange("from")} max={maxDate} placeholder="Choose a start date..." />
        </Grid>
        <Grid item xs={6}>
            <Typography className={"report-range-label"} component={"span"} variant={"span"}>
                To:
            </Typography>
            <DatePicker value={reportRange.to} onChange={onChange("to")} max={maxDate} placeholder="Choose an end date..." />
        </Grid>
        <Grid item xs={6}>
            &nbsp;
        </Grid>
        <Grid item xs={6}>
            <Button onClick={handleEmailReport} color={"primary"} variant={"contained"} disabled={!validateReportRange()}>
                Email Report
            </Button>
        </Grid>
        <EmailReportModal
            open={showEmailReportModal}
            cancel={handleCancelEmailReport}
            sendNow={handleSendEmailReport}
        />
        <SuccessDialog handleOk={() => {
            setShowSuccessDialog(false)
        }} message={"Report Has Been Sent."} open={showSuccessDialog} />
        <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={showReportGenerationInProgress}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogContent style={{ margin: "auto" }}>
                <Typography style={{fontWeight: "bold"}}>We are generating the report and will be emailed shortly.</Typography>
                <Typography>Note: It could take few minutes before it arrives in your inbox</Typography>
            </DialogContent>
        </Dialog>
    </Grid>
};

export default CustomerReporting;
